<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer000">
<h1 class="Titlepg1">Moon Milk</h1>
<h2 class="Titlepg2">Easy Recipes for peaceful sleep</h2>
<div class="rule"></div>
<h3 class="Titlepg3">Anni Daulter</h3>
<p class="Titlepg4">with Jessica Booth and Alexis Donahue</p>
<p class="Titlepg5">Photographs by<em class="Emphasis CharOverride-1"> </em><em class="Emphasis _idGenCharOverride-1">Megan Elizondo </em></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="small" id="_idContainer001">
<img alt="logo" class="_idGenObjectAttribute-1 logo" src="image/logo.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer002">
<img alt="Slumber shots in stemmed glasses with a rose." class="full" src="image/night_owl-slumber_shots.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="Copyright">Digital Edition 1.0</p>
<p class="Copyright ParaOverride-1">Text © 2020 Anni Daulter</p>
<p class="Copyright">Photographs © 2020 Megan Elizondo</p>
<p class="Copyright ParaOverride-1">All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.</p>
<p class="Copyright ParaOverride-1">Published by</p>
<p class="Copyright">Gibbs Smith</p>
<p class="Copyright">P.O. Box 667</p>
<p class="Copyright">Layton, Utah 84041</p>
<p class="Copyright ParaOverride-1">1.800.835.4993 orders</p>
<p class="Copyright">www.gibbs-smith.com</p>
<p class="Copyright ParaOverride-1">Contributing writers Jessica Booth and Alexis Donahue</p>
<p class="Copyright ParaOverride-1">Library of Congress Cataloging-in-Publication Data</p>
<p class="Copyright ParaOverride-1">Names: Daulter, Anni, author. | Elizondo, Megan, photographer.  </p>
<p class="Copyright">Title: Moon milk : easy recipes for peaceful sleep / Anni Daulter ; photographs by Megan Elizondo.  </p>
<p class="Copyright">Description: First edition. | Layton : Gibbs Smith, [2020] | </p>
<p class="Copyright">Identifiers: LCCN 2019036072 | ISBN 9781423654483 (hardcover) | ISBN 9781423654490 (epub)  </p>
<p class="Copyright">Subjects: LCSH: Beverages. | LCGFT: Cookbooks. </p>
<p class="Copyright">Classification: LCC TX815 .D24 2020 | DDC 641.2—dc23 </p>
<p class="Copyright">LC record available at https://lccn.loc.gov/2019036072</p>
</div>
<div class="forespace linen" id="_idContainer004">
<div class="rule helf"></div>
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="Dedication">To our families and friends who supported and loved our moonalicious vision!</p>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer006">
<img alt="Photo of Sleeping Beauty in various shades of blue and purple." class="full" src="image/starlit_soother-sleeping_beauty_v2.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Moon_Milk_Digital.vue?137c5182